/* eslint-disable indent */
import { useEffect } from 'react';
import Card from '@/components/Card';
import { Button } from '@/components/Button';
import { Controller, FieldValues, Path } from 'react-hook-form';
import { FormManagementProps } from '@/type/form.types';
import { TitleSection } from '@/components/Header/Section/TitleSection';
import { RichTextEditor } from '@/components/Custom/RichTextEditor';

export const GlobalSettingVariableNoteManagement = <
  TSchema extends FieldValues,
>({
  t,
  data,
  control,
  setValue,
  submitDisabled,
  onSubmit,
}: FormManagementProps<TSchema>) => {
  /**
   * === Set Fields Initial Values section ===
   */
  useEffect(() => {
    if (setValue && data) {
      setValue('variableNote' as Path<TSchema>, data.variableNote ?? '');
    }
  }, [setValue, data]);
  /**
   * === END OF Set Fields Initial Values section ===
   */

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
    >
      <Card
        title={
          <TitleSection
            defaultIconClassName="-mt-0.75 ki-notepad-bookmark"
            textClassName="flex flex-1 font-normal"
            text={
              <div className="flex flex-1 items-center gap-5">
                <div className="flex flex-1 font-semibold">
                  {t('variablesForEmailTemplates')}
                </div>
              </div>
            }
          />
        }
        footer={
          <Button
            buttonClassName="px-8"
            text={
              submitDisabled ? `${t('common:loading')}...` : t('common:save')
            }
            disabled={submitDisabled}
          />
        }
        bodyClassName="py-8 flex flex-col gap-8"
      >
        <>
          <div className="mt-0.5 flex gap-2">
            <i className="-mt-0.5 ki-outline ki-information text-[21px] text-primary" />
            <div className="text-sm text-gray-600">{t('variableInfos')}</div>
          </div>
          <Controller
            name="variableNote"
            control={control}
            render={({ field }) => (
              <RichTextEditor value={field.value} onChange={field.onChange} />
            )}
          />
        </>
      </Card>
    </form>
  );
};
